import { HttpMethod } from "../types/index.js";
export default function (provider) {
  return {
    createMultisigs(body) {
      return provider.send("/multisigs/requests", HttpMethod.POST, body);
    },

    getMultisigsOutputs(params) {
      return provider.send("/multisigs/outputs", HttpMethod.GET, "", params);
    },

    multisigsAction(id, action, pin) {
      return provider.send(`/multisigs/requests/${id}/${action}`, HttpMethod.POST, {
        action,
        pin
      });
    }

  };
}